(ns frontend.view.reports.custom.alj-2.deals-per-status-pie
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn deals-per-status
  [deals]
  (let [grouped-deals (group-by :oppo/status deals)]
    {:series    [{:name         (loc/tr :oppo/status)
                  :colorByPoint true
                  :data         (->> grouped-deals
                                     (map (fn [[status oppos]]
                                            {:name      (loc/tr status)
                                             :y         (count oppos)
                                             :ticketSizeSum (alj-utils/ticket-size-sum-millions oppos)
                                             :drilldown (loc/tr status)}))
                                     (vec))}]
     :drilldown {:series (->> grouped-deals
                              (map (fn [[status oppos]]
                                     {:name (loc/tr status)
                                      :id   (loc/tr status)
                                      :data (->> oppos
                                                 (mapcat :oppo/group-business-units)
                                                 (frequencies)
                                                 (map (fn [[bu-id f]]
                                                        [(entity/display-string (session/get-entity bu-id))
                                                         f]))
                                                 (vec))}))
                              (vec))}}))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:oppo.status/ok :oppo.status/passed :oppo.status/portfolio]]
                          [:date-passed #{:oppo.status/passed} [:oppo.status/ok :oppo.status/passed :oppo.status/portfolio]]
                          [:date-portfolio #{:oppo.status/portfolio} [:oppo.status/ok :oppo.status/passed :oppo.status/portfolio]]])]
    (fn [{:keys [state]}]
      (let [all-deals (alj/all-deals)
            passed-deals (->> all-deals
                              (cu/filter-by :oppo/status :oppo.status/passed)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :oppo.status/passed)
                              (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :oppo.status/passed)
                              (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :oppo.status/passed))
            portfolio-deals (->> all-deals
                                 (cu/filter-by :oppo/status :oppo.status/portfolio)
                                 (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :oppo.status/portfolio)
                                 (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :oppo.status/portfolio)
                                 (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom
                                                                              :date-portfolio :oppo.status/portfolio))
            active-deals (->> all-deals
                              (cu/filter-by :oppo/status :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :oppo.status/ok))
            deals-by-status (concat passed-deals
                                    portfolio-deals
                                    active-deals)
            chart-data (deals-per-status deals-by-status)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (sort-by first)
                             (doall))
            view-name (loc/tr :number-of-deals-per-status)]
        [:<>
         [alj-components/alj-pie-chart-v2
          {:view-name       view-name
           :total-deals     (count deals-by-status)
           :total-amount    (alj-utils/ticket-size-sum-billions deals-by-status)
           :report-data     export-data
           :chart-data      chart-data
           :date-state-atom date-state-atom}]]))))
